/* System defined core library */
import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { MetricApiService } from '../../../scheduling/shared/services/metric-api.service';
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';
import { RoutingService } from '../../services/routing.service';

/* User defined models */
import { Client } from '../../models/scheduling/client.model';

/* User defined constants/enums */
import { LogLevel } from '../../enums/scheduling.enum';

/* Images */
const proschedulerImg = require('../../../../../Assets/images/pro_scheduler.png');
const dttGif = require('../../../../../Assets/App_themes/DTT/images/dtt_head.gif');
const epsoImg = require('../../../../../Assets/App_themes/EPSO/images/topbg.jpg');
const cfaImg = require('../../../../../Assets/App_themes/CFA/images/cfa_head.png');
const fitchLeftImg = require('../../../../../Assets/App_themes/FTLRN/images/fitch_left.svg');

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  /* User defined private/public variables */
  public proscheduler = proschedulerImg;
  public dtt = dttGif;
  public epso = epsoImg;
  public cfa = cfaImg;
  public fitchLeft = fitchLeftImg;

  private pathLock = false;
  private originLocation = window.location.origin;
  private program: any;
  private client: Client;
  private programCode: any;
  public clientCode: string = "";

  /* Service subscriptions */
  client$: Subscription;
  pathLock$: Subscription;
  program$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private metricApiService: MetricApiService,
    private routingService: RoutingService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {
    this.client$ = selectedExamDetailService.client.subscribe(
      client => {
        this.client = client;
      });

    this.pathLock$ = selectedExamDetailService.pathLock.subscribe(
      pathLock => {
        this.pathLock = pathLock;
      });

    this.program$ = selectedExamDetailService.program.subscribe(
      program => {
        this.program = program;
      });

    this.programCode = selectedExamDetailService.programCode;
  }

  /* Initialize the component & call required methods when component loaded first time. */
  ngOnInit() {

  }

  // When leave button on  pop-up message click then below code will get execute and service data will clear:
  @HostListener('window:unload', ['$event']) unloadHander(event: any) {
    this.selectedExamDetailService.resetExamService();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    setTimeout(() => {
      if (this.selectedExamDetailService.isFlowComplete) {
        this.metricApiService.log(LogLevel.Debug, `Candidate used unknown navigation in completed workflow. Directed to homepage.`);
        // this.routingService.homeNavigation();
      }
    }, 0);
  }

  /* Move to home */
  navigateToHome(): void {
    window.location.replace(window.location.origin);
  }

  skipNavigation() {
    const contentBody: HTMLElement = document.getElementById('content-body');
    if (!!contentBody) {
      contentBody.focus();
    }
  }

  /* get CSS style class based on program code */
  getClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';
    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
    return `navbar navbar-flex navbar-${programCode} navbar-${clientCode} navbar-toggleable navbar-light`;
  }

  getNavClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';
    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
    return `navbar-brand-left navbar-brand-left-${programCode} navbar-brand-left-${clientCode}`;
  }

  getSubHeaderClass() {
    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
    return `${clientCode}`;
  }

  getTimerClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';
    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
    return `${programCode} ${clientCode}`;
  }

  /* Determine path lock based on program codes */
  getPathLock() {
    const programCodes: string[] = ['DTT', 'ESDS', 'CPC', 'ADI']; // add them in the array
    if (this.selectedExamDetailService.programCode) {
      // to check if any other programs (skinned) would need pathLock
      let doesPrgNeedPathLock = programCodes.some(elm => elm === this.selectedExamDetailService.programCode.toUpperCase());
      if (doesPrgNeedPathLock) {
        this.pathLock = true;
        this.selectedExamDetailService.setSchedulePathLock = true;
        this.selectedExamDetailService.setReschedCancelPathLock = true;
        this.selectedExamDetailService.setCancelPathLock = true;
        this.selectedExamDetailService.setReschedulePathLock = true;
        this.selectedExamDetailService.setSeatAvailabilityPathLock = true;
        this.selectedExamDetailService.setConfirmPathLock = true;
        this.selectedExamDetailService.pathLockTestInformation = true;
      }
    }

    const clientCodes: string[] = ['EPSO', 'CFA', 'CFAD', 'CFAS']; // add them in the array
    if (this.selectedExamDetailService.clientCode) {
      let doesClntNeedPathLock = clientCodes.some(elm => elm === this.selectedExamDetailService.clientCode.toUpperCase());
      if (doesClntNeedPathLock) {
        this.pathLock = true;
        this.selectedExamDetailService.setSchedulePathLock = true;
        this.selectedExamDetailService.setReschedCancelPathLock = true;
        this.selectedExamDetailService.setCancelPathLock = true;
        this.selectedExamDetailService.setReschedulePathLock = true;
        this.selectedExamDetailService.setSeatAvailabilityPathLock = true;
        this.selectedExamDetailService.setConfirmPathLock = true;
        this.selectedExamDetailService.pathLockTestInformation = true;
      }
    }
    return this.pathLock;
  }
}
